export const SKILLS = [
    {
        title: "Frontend",
        icon:"../../src/assests/front-end.png",
        skills:[
            { skill: "HTML5", percentage: "80%" },
            { skill: "CSS ", percentage: "70%" },
            { skill: "JavaScript", percentage: "65%" },
            { skill: "React.js", percentage: "70%" },
        ],
    },
    {
        title: "Backend",
        icon: "./assets/back-end.png", 
        skills:[
            {skill: "Node. js", percentage:"70%"},
            {skill: "Java", percentage: "75%"},
            {skill: "Python", percentage: "65%"},
        ],
    },
    {
        title: "Tools",
        icon: "./assets/tools.png",
        skills: [
            { skill: "Git & GitHub", percentage:"85%" },
            { skill: "Visual Studio Code", percentage: "75%" },
            { skill: "Webpack", percentage: "60%" },
            { skill: "Responsive Design", percentage: "70%" },
        ],
    },
    {
        title: "SoftSkills",
        icon: "./assets/soft-skills.png", 
        skills:[
            { skill: "Problem-solving", percentage: "80%" },
            { skill: "Collaboration", percentage: "85%" },
            { skill: "Attention to Detail", percentage: "75%" },
        ],
    },
];

export const PROJECTS = [
    {
        title: "HappyPaws Project ",
        keycomponents: "ReactJs , Firebase , Python , Flask",
        description: [
            "Developed a full stack web app by react,  python and firebase database.",
            " Trained the ML model using python",
            " Integrated Ml model to the front end by Flask",
            "Deployed both Ml model and Frontend"
        ],
        Github:"https://github.com/dileepaM-7/SDGP-HappyPaws.git",
        App:"https://sdgp-happy-paws.vercel.app"
    },
    {
        title: "Yoga Project (MERN)",
        keycomponents: "Mongodb, ExpressJs, ReactJs, NodeJs",
        description: [
            "Developed a full stack web app by react, Nodejs, ExpressJs and by Mongodb.",
            " Where the users can logging as a yoga instructor or a student",
            " Hosted using vercel",
        ],
        Github:"https://github.com/dileepaM-7/yoga-master.git",
        
    },
    {
        title: "Java (OOP) Product Buying System in Java with Java Swing",
        keycomponents: "Java OOP, Java Swing UI, Event Handling",
        description: [
            "Created a Java program using Object-Oriented Programming to simulate a product buying system.",
            "The user interacts with a graphical interface built with Java Swing",
        ],
        Github:"https://github.com/dileepaM-7/OOP-CourseWork-2024.git",
    },
    {
        title: "Portfolio using React",
        keycomponents: "React for building components ",
        description: [
            "Built a personal portfolio using the React framework, showcasing skills, projects, and other relevant information.",
            " React is a JavaScript library for building user interfaces, commonly used for creating dynamic and interactive web applications.",
        ],
        Github:"https://github.com/dileepaM-7/Portfolio24.git",
    },
    {
        title: "Movie Ticket Booking System in Java",
        keycomponents: "Java programming, user interface design,booking logic.",
        description: [
            "Developed a Java program that allows users to book movie tickets.",
            "The system likely includes features such as choosing seats and completing the booking process.",
        ],
    },
]

